var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_59",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.495605,
    y: 0.967773,
    width: 38.0013,
    height: 38.0013,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99588 31.0522H14.746V21.5519H24.2464V31.0522H28.9966V16.8017L19.4962 9.67649L9.99588 16.8017V31.0522ZM6.8291 34.219V15.2184L19.4962 5.71802L32.1633 15.2184V34.219H21.0796V24.7187H17.9128V34.219H6.8291Z",
    fill: "#33475B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5b99dc95f07e138443a529f9d9116fab.svg";
export { ForwardRef as ReactComponent };